var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAmTooltipHelper = function SvgAmTooltipHelper(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 124,
    viewBox: "0 0 93 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_191_6441)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.855739,
    y: 3.3887,
    width: 84.944,
    height: 119.338,
    rx: 2.81104,
    fill: "#FAFAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.855739,
    y: 3.3887,
    width: 84.944,
    height: 119.338,
    rx: 2.81104,
    stroke: "#170559",
    strokeWidth: 1.71441
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.60688,
    y: 8.13886,
    width: 75.4422,
    height: 29.7425,
    rx: 2.38436,
    fill: "#E0E7FF",
    stroke: "#2E0DA6",
    strokeWidth: 1.10047
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.05664,
    y: 45.1968,
    width: 34.5996,
    height: 7.22329,
    rx: 1.4673,
    fill: "#EAECF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.05664,
    y: 55.9688,
    width: 76.5441,
    height: 49.32,
    rx: 1.4673,
    fill: "#EAECF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.1064,
    y: 108.224,
    width: 19.4932,
    height: 8.86934,
    rx: 1.4673,
    fill: "#EAECF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.1167,
    y: 13.657,
    width: 1.4673,
    height: 8.80379,
    fill: "#313336"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.0513,
    y: 13.657,
    width: 1.4673,
    height: 8.80379,
    fill: "#313336"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.9858,
    y: 13.657,
    width: 1.4673,
    height: 8.80379,
    fill: "#313336"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.9204,
    y: 13.657,
    width: 1.4673,
    height: 8.80379,
    fill: "#313336"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.855,
    y: 13.657,
    width: 1.4673,
    height: 8.80379,
    fill: "#313336"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.7896,
    y: 13.657,
    width: 1.4673,
    height: 8.80379,
    fill: "#313336"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.7241,
    y: 13.657,
    width: 1.4673,
    height: 8.80379,
    fill: "#313336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1477 32.0291V26.7621H12.1714L14.5378 30.3154H14.5527V26.7621H15.5838V32.0291H14.5378L12.2011 28.5499H12.1862V32.0291H11.1477ZM17.8492 28.765C17.5525 28.765 17.3077 28.6686 17.1 28.4683C16.8923 28.268 16.7958 28.0232 16.7958 27.7339C16.7958 27.452 16.8997 27.2146 17.1074 27.0069C17.3151 26.7992 17.5673 26.6953 17.8492 26.6953C18.1311 26.6953 18.3759 26.7992 18.5836 27.0069C18.7914 27.2146 18.9026 27.4594 18.9026 27.7413C18.9026 28.0232 18.7988 28.268 18.5911 28.4683C18.3834 28.6686 18.1385 28.765 17.8492 28.765ZM17.8492 28.1716C17.9679 28.1716 18.0718 28.1345 18.1608 28.0454C18.2424 27.9638 18.2869 27.86 18.2869 27.7339C18.2869 27.6152 18.2424 27.5113 18.1534 27.4223C18.0644 27.3333 17.9679 27.2888 17.8492 27.2888C17.7231 27.2888 17.6193 27.3333 17.5303 27.4223C17.4412 27.5113 17.4041 27.6152 17.4041 27.7339C17.4041 27.86 17.4412 27.9638 17.5303 28.0454C17.6193 28.1345 17.7231 28.1716 17.8492 28.1716ZM20.1062 32.0291V26.7621H22.1017C22.71 26.7621 23.1625 26.9253 23.4741 27.2443C23.7783 27.5633 23.934 27.9861 23.934 28.5128C23.934 29.3362 23.5631 29.8629 22.8361 30.1003L24.1566 32.0291H22.9177L21.7382 30.2264H21.1374V32.0291H20.1062ZM21.1374 29.3065H21.894C22.2056 29.3065 22.443 29.2398 22.6062 29.0914C22.7694 28.9431 22.8584 28.7502 22.8584 28.498C22.8584 28.2532 22.7768 28.0603 22.621 27.9119C22.4578 27.7635 22.2353 27.6894 21.9385 27.6894H21.1374V29.3065ZM25.2302 32.0291V26.7621H27.1812C27.7895 26.7621 28.2495 26.9253 28.5536 27.2443C28.8578 27.5633 29.0136 27.9861 29.0136 28.5128C29.0136 29.0766 28.8355 29.5068 28.4943 29.7962C28.1456 30.0855 27.6709 30.2264 27.0774 30.2264H26.2614V32.0291H25.2302ZM26.2614 29.3065H26.9661C27.2777 29.3065 27.5225 29.2398 27.6857 29.0914C27.8489 28.9431 27.9305 28.7502 27.9305 28.498C27.9305 28.2457 27.8489 28.0529 27.6931 27.9045C27.5373 27.7635 27.3148 27.6894 27.018 27.6894H26.2614V29.3065ZM30.108 32.0291V26.7621H32.059C32.6673 26.7621 33.1272 26.9253 33.4313 27.2443C33.7355 27.5633 33.8913 27.9861 33.8913 28.5128C33.8913 29.0766 33.7132 29.5068 33.372 29.7962C33.0233 30.0855 32.5486 30.2264 31.9551 30.2264H31.1391V32.0291H30.108ZM31.1391 29.3065H31.8438C32.1554 29.3065 32.4002 29.2398 32.5634 29.0914C32.7266 28.9431 32.8082 28.7502 32.8082 28.498C32.8082 28.2457 32.7266 28.0529 32.5708 27.9045C32.415 27.7635 32.1925 27.6894 31.8958 27.6894H31.1391V29.3065ZM36.5732 32.0958C35.8314 32.0958 35.1934 31.8213 34.6519 31.2576L35.2824 30.4861C35.4679 30.7012 35.6756 30.8644 35.913 30.9757C36.1503 31.0944 36.3729 31.1463 36.5954 31.1463C36.8328 31.1463 37.0183 31.1018 37.1518 30.9979C37.2779 30.8941 37.3447 30.7605 37.3447 30.5899C37.3447 30.4119 37.2779 30.2709 37.1444 30.1671C37.0109 30.0706 36.7735 29.9594 36.4322 29.8407C36.2394 29.7813 36.0836 29.722 35.95 29.6626C35.8165 29.6033 35.6756 29.5291 35.5272 29.4327C35.3788 29.3436 35.2527 29.2398 35.1637 29.1359C35.0673 29.0321 34.9857 28.8985 34.9263 28.7353C34.867 28.5721 34.8373 28.3941 34.8373 28.2012C34.8373 27.7858 35.0005 27.4297 35.3269 27.1404C35.6533 26.8511 36.0539 26.7027 36.5287 26.6953C37.1666 26.6953 37.7601 26.9179 38.3091 27.363L37.7008 28.1493C37.2705 27.8081 36.8922 27.63 36.5509 27.63C36.3581 27.63 36.2097 27.6819 36.091 27.771C35.9723 27.8674 35.913 27.9935 35.913 28.1567C35.913 28.3125 35.9723 28.4312 36.0984 28.5202C36.2245 28.6092 36.4619 28.7205 36.8031 28.854C37.3447 29.0692 37.7008 29.2324 37.8714 29.3436C38.2497 29.6033 38.4426 29.9742 38.4426 30.4638C38.4426 30.8347 38.3387 31.1463 38.1459 31.3985C37.9456 31.6507 37.7082 31.8362 37.4411 31.94C37.1666 32.0439 36.8773 32.0958 36.5732 32.0958Z",
    fill: "#313336"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.4697,
    y: 13.657,
    width: 1.4673,
    height: 8.80379,
    fill: "#313336"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.4043,
    y: 13.657,
    width: 1.4673,
    height: 8.80379,
    fill: "#313336"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.3389,
    y: 13.657,
    width: 1.4673,
    height: 8.80379,
    fill: "#313336"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.2734,
    y: 13.657,
    width: 1.4673,
    height: 8.80379,
    fill: "#313336"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.208,
    y: 13.657,
    width: 1.4673,
    height: 8.80379,
    fill: "#313336"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.1431,
    y: 13.657,
    width: 1.4673,
    height: 8.80379,
    fill: "#313336"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.0771,
    y: 13.657,
    width: 1.4673,
    height: 8.80379,
    fill: "#313336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1432 32.0288V26.7618H53.1669L55.5333 30.3152H55.5482V26.7618H56.5793V32.0288H55.5333L53.1966 28.5496H53.1818V32.0288H52.1432ZM58.8448 28.7648C58.548 28.7648 58.3032 28.6683 58.0955 28.468C57.8878 28.2677 57.7914 28.0229 57.7914 27.7336C57.7914 27.4517 57.8952 27.2144 58.1029 27.0066C58.3107 26.7989 58.5629 26.6951 58.8448 26.6951C59.1267 26.6951 59.3715 26.7989 59.5792 27.0066C59.7869 27.2144 59.8982 27.4592 59.8982 27.741C59.8982 28.0229 59.7943 28.2677 59.5866 28.468C59.3789 28.6683 59.1341 28.7648 58.8448 28.7648ZM58.8448 28.1713C58.9635 28.1713 59.0673 28.1342 59.1563 28.0452C59.2379 27.9636 59.2824 27.8597 59.2824 27.7336C59.2824 27.6149 59.2379 27.5111 59.1489 27.4221C59.0599 27.333 58.9635 27.2885 58.8448 27.2885C58.7187 27.2885 58.6148 27.333 58.5258 27.4221C58.4368 27.5111 58.3997 27.6149 58.3997 27.7336C58.3997 27.8597 58.4368 27.9636 58.5258 28.0452C58.6148 28.1342 58.7187 28.1713 58.8448 28.1713ZM60.6492 32.0288L62.6002 26.7618H63.6091L65.5675 32.0288H64.4771L64.1136 30.9754H62.0958L61.7397 32.0288H60.6492ZM62.3925 30.0852H63.8168L63.1121 28.0229H63.0973L62.3925 30.0852ZM66.523 32.0288V26.7618H67.5689L69.1861 29.7588H69.201L70.8181 26.7618H71.8641V32.0288H70.8256V28.7722H70.8107L69.5274 31.0348H68.8523L67.5764 28.7648H67.5615V32.0288H66.523Z",
    fill: "#313336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0769 47.4645L81.2378 37.6543C84.4123 33.61 86.1348 28.6158 86.1284 23.4744C86.1284 18.8956 84.7707 14.4196 82.2268 10.6124C79.6829 6.80529 76.0673 3.83799 71.837 2.08575C67.6067 0.333517 62.9519 -0.124947 58.461 0.768334C53.9702 1.66162 49.8451 3.86652 46.6074 7.10423C43.3697 10.3419 41.1648 14.467 40.2715 18.9579C39.3782 23.4487 39.8367 28.1036 41.5889 32.3338C43.3412 36.5641 46.3085 40.1798 50.1156 42.7236C53.9228 45.2675 58.3987 46.6253 62.9776 46.6253C68.1189 46.6316 73.1132 44.9092 77.1575 41.7346L86.9677 51.5738C87.2367 51.845 87.5567 52.0603 87.9094 52.2072C88.262 52.3541 88.6403 52.4298 89.0223 52.4298C89.4043 52.4298 89.7826 52.3541 90.1352 52.2072C90.4878 52.0603 90.8079 51.845 91.0769 51.5738C91.3482 51.3047 91.5635 50.9847 91.7104 50.632C91.8573 50.2794 91.9329 49.9011 91.9329 49.5191C91.9329 49.1371 91.8573 48.7588 91.7104 48.4062C91.5635 48.0536 91.3482 47.7335 91.0769 47.4645V47.4645ZM45.6144 23.4744C45.6144 20.0403 46.6327 16.6833 48.5406 13.8279C50.4485 10.9726 53.1603 8.74708 56.333 7.43291C59.5057 6.11873 62.9968 5.77488 66.3649 6.44484C69.7331 7.11481 72.8269 8.76849 75.2552 11.1968C77.6834 13.625 79.3371 16.7189 80.0071 20.087C80.677 23.4551 80.3332 26.9463 79.019 30.119C77.7048 33.2917 75.4794 36.0034 72.624 37.9113C69.7686 39.8192 66.4117 40.8375 62.9776 40.8375C58.3726 40.8375 53.9562 39.0082 50.6999 35.752C47.4437 32.4958 45.6144 28.0794 45.6144 23.4744Z",
    fill: "#2E0DA6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_191_6441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92.6265,
    height: 124,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAmTooltipHelper);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "am_tooltip_helper.fb755a38a21a364b25fe24989951c682.svg";